module.exports = __webpack_public_path__ + "img/cover3d_item.cb67ad5e.svg";